import React from "react";
import GlobalStyle from "../src/styles/global";
import theme from "../src/styles/theme";
import { ThemeProvider } from "styled-components";
import { DataUtilsProvider } from "../src/contexts/DataUtils";
import { LoginContextProvider } from "../src/contexts/Login";
import VLibras from "../src/components/shared/VLibras";

import loadable from "@loadable/component";

const Layout = loadable(() => import("../src/pages/layout"));

export function wrapRootElement({ element }) {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <LoginContextProvider>
          <DataUtilsProvider>
            <GlobalStyle />
            <VLibras />
            {element}
          </DataUtilsProvider>
        </LoginContextProvider>
      </Layout>
    </ThemeProvider>
  );
}
